import "./corralpagewrapper.css";
import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useCurrentHeader } from "../../../hooks/corral/currentHeader";
import { useCurrentUser } from "../../../hooks/currentUser";
import { HeaderProvider } from "../../../contexts/corral/corralHeaderContext";

import {
  Container,
  Card,
  Center,
  Title,
  Grid,
  LoadingOverlay,
} from "@mantine/core";
import Breadcrumbs from "./Breadcrumbs";

import ActiveCharacterCard from "./side-cards/active-character/ActiveCharacter";
import QuickNavigateCard from "./side-cards/QuickNavigate";

const CorralPageWrapper = () => {
  const { headerRef } = useCurrentHeader();
  const { currentUser } = useCurrentUser();
  const location = useLocation();
  if (!currentUser) {
    return (
      <LoadingOverlay
        visible={!currentUser}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
    );
  }

  // Only render the Corral Page if there is an active character
  // Every page requires that.
  if (
    !currentUser.activeCharacter ||
    currentUser.activeCharacter.campaignId !== "corral"
  ) {
    return (
      <Navigate
        to={`/settings/profile?needsActiveCharacterReferer=${location.pathname}`}
      />
    );
  }

  return (
    <Center px={0} mx={0}>
      <Container fluid px="xs" mt="xs" pt="xs" style={{ width: "100%" }}>
        <Grid justify="center" style={{ width: "100%" }}>
          <Grid.Col span={4}>
            <ActiveCharacterCard
              maxHeight={
                !location.pathname.includes("homepage") ? "50%" : "100%"
              }
            />
            {!location.pathname.includes("homepage") && <QuickNavigateCard />}
          </Grid.Col>
          <Grid.Col span="auto" md={8} lg={6}>
            <Card
              shadow="sm"
              padding="lg"
              radius="md"
              withBorder
              style={{ minHeight: "400px" }}
            >
              <Card.Section ref={headerRef} withBorder inheritPadding py="xs">
                <Breadcrumbs />
                <Title order={2} align="center">
                  The Corral
                </Title>
              </Card.Section>

              <Card.Section inheritPadding py="xs">
                {<Outlet />}
              </Card.Section>
            </Card>
          </Grid.Col>
        </Grid>
      </Container>
    </Center>
  );
};

export default () => (
  <HeaderProvider>
    <CorralPageWrapper />
  </HeaderProvider>
);
